<template>
    <div>
      <div v-if="!isAuthenticated" class="password-overlay">
      <div class="password-modal">
        <h4 class="mb-3">🔒 Enter Password to View Report</h4>
        <input
          type="password"
          v-model="enteredPassword"
          @keyup.enter="verifyPassword"
          class="form-control mb-3"
          placeholder="Password"
        />
        <button @click="verifyPassword" class="btn btn-primary btn-block">
          Access Report
        </button>

        <p v-if="authError" class="text-danger mt-2">{{ authError }}</p>
      </div>
    </div>
        <div v-if="isLoading" class="text-center py-5">
            <div class="spinner-border text-primary" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            <p class="mt-3 text-muted">Fetching product report data...</p>
        </div>
        <div v-if="!isLoading && isAuthenticated">
            <div class="product-report-page">
    
                <!-- PAGE HEADER -->
                <div class="d-flex justify-content-between align-items-center mb-4">
                    <h2 class="page-title">Product Report</h2>
    
    
                </div>
    
                <!-- CARD -->
                <div class="report-card p-4">
    
                    <!-- SEARCH + MONTH FILTER -->
                    <div class="d-flex justify-content-between flex-wrap mb-3">
    
                        <input v-model="search" type="text" class="form-control" placeholder="Search..." />
    
    
                        <div>
                            <!-- <select v-model="selectedMonth" class="form-control custom-select mb-3">
              <option v-for="m in months" :key="m" :value="m">{{ m }}</option>
            </select> -->
                        </div>
                    </div>
    
                    <!-- TABLE -->
                    <div class="table-responsive">
                        <table class="table table-border table-hover">
                            <thead class="bg-default">
                                <tr>
    
                                    <th>Class Name</th>
                                    <th>Teachers</th>
                                    <th>Bilangan Terjual</th>
                                    <th>Jumlah Nilai (RM)</th>
                                    <th style="width: 80px">Action</th>
                                </tr>
                            </thead>
    
                            <tbody>
                                <tr v-for="row in paginatedData" :key="row.id">
    
                                    <td>{{ row.ProductName }} (Bulan {{ row.Month }})</td>
    
                                    <td>
                                        <div class="align-items-center">
                                            <!--  -->
                                            <div v-for="(teacherName, index) in row.Teachers" :key="index" class="ml-2">
    
                                                <div class="m-1"><img :src="teacherName.ProfilePicturePath" class="avatar-img" /> {{ teacherName.Name }}</div>
    
                                            </div>
    
    
                                        </div>
                                    </td>
    
                                    <td>{{ row.TotalSales }}</td>
    
                                    <td>RM {{ row.TotalAmount }}</td>
    
                                    <td>
                                        <button class="btn btn-link p-0 mr-2 text-danger">
                    <i class="cil-trash"></i>
                  </button>
                                        <button class="btn btn-link p-0 text-dark">
                    <i class="cil-pencil"></i>
                  </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
    
                    <!-- PAGINATION -->
                    <div class="d-flex justify-content-between align-items-center mt-3 flex-wrap">
                        <small>
            Showing {{ start + 1 }} to {{ end }} of {{ filteredData.length }} entries
          </small>
    
                        <ul class="pagination mb-0 mt-2">
                            <li class="page-item" :class="{ disabled: page === 1 }" @click="page--">
                                <a class="page-link">‹</a>
                            </li>
    
                            <li class="page-item" v-for="n in totalPages" :key="n" :class="{ active: page === n }" @click="page = n">
                                <a class="page-link">{{ n }}</a>
                            </li>
    
                            <li class="page-item" :class="{ disabled: page === totalPages }" @click="page++">
                                <a class="page-link">›</a>
                            </li>
                        </ul>
                    </div>
                </div>
    
            </div>
        </div>
    </div>
</template>
  
<script>
const ACCESS_PASSWORD = "Flyhigh192077**";
export default {
    name: "ProductReport",

    data() {
        return {
            search: "",
            selectedMonth: "June 2025",
            months: ["June 2025", "May 2025", "April 2025"],

            page: 1,
            perPage: 10,
            selected: [],
            selectAll: false,


            rows: [],
            isLoading: false,

            // Password popup
            isAuthenticated: false,
            enteredPassword: '',
            authError: '',
        };
    },
    async mounted() {
       
        let savedAuth = localStorage.getItem("affiliateReportAuth");

          if (savedAuth === "true") {
              this.isAuthenticated = true;
              this.GetListProductReport(); // Auto-load data
              return;
          }

          // Still need login check for app
          let isAuth = await this.UserAuth();
          if (!isAuth) this.GoToLogin();
    },


    computed: {
        filteredData() {
            if (!this.search) return this.rows;

            const s = this.search.toLowerCase();
            return this.rows.filter(item => {
                  const productNameMatch =
                      item.ProductName &&
                      item.ProductName.toLowerCase().includes(s);

                  const monthMatch =
                      item.Month &&
                      item.Month.toLowerCase().includes(s);

                  const teacherMatch =
                      item.Teachers &&
                      item.Teachers.some(t =>
                          t.Name && t.Name.toLowerCase().includes(s)
                      );

                  return productNameMatch || monthMatch || teacherMatch;
              });
        },

        start() {
            return (this.page - 1) * this.perPage;
        },

        end() {
            return Math.min(this.start + this.perPage, this.filteredData.length);
        },

        paginatedData() {
            // This is now safe because 'this.filteredData' is always an array
            return this.filteredData.slice(this.start, this.end);
        },

        totalPages() {
            return Math.ceil(this.filteredData.length / this.perPage);
        }
    },

    watch: {
        selected() {
            this.selectAll = this.selected.length === this.rows.length;
        }
    },

    methods: {
        toggleAll() {
            this.selected = this.selectAll ? this.rows.map(r => r.id) : [];
        },
        async GetListProductReport() {
            try {
                this.isLoading = true;
                const response = await this.$API.get(this.$GetTotalAmountPerProduct);

                if (response.status === 200 && response.data) {
                    this.isLoading = false;
                    this.rows = response.data;



                }

            } catch (err) {
                console.error("Error loading report:", err);
            }
        },
        verifyPassword() {
            this.authError = '';

            if (this.enteredPassword === ACCESS_PASSWORD) {
                this.isAuthenticated = true;
                this.enteredPassword = '';

                // 🔥 Save auth state so refresh won't require re-entering password
                localStorage.setItem("affiliateReportAuth", "true");

            } else {
                this.authError = 'Incorrect password. Please try again.';
            }
        },

    }
};
</script>
  
<style scoped>
.product-report-page {
    background: #f7f7f7;
    min-height: 100vh;
}

.page-title {
    font-weight: 600;
}

.report-card {
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 3px 12px rgba(0, 0, 0, 0.05);
}

.avatar-img {
    width: 38px;
    height: 38px;
    border-radius: 50%;
}

.table thead th {
    color: #6c757d;
    font-weight: 600;
    font-size: 14px;
}

.pagination .page-item.active .page-link {
    background: #2563eb;
    border-color: #2563eb;
    color: #fff;
}

.page-link {
    border-radius: 6px !important;
}

/* --- NEW STYLES FOR PASSWORD POPUP --- */

.password-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1050;
    /* Above other content */
}

.password-modal {
    background: white;
    padding: 30px;
    border-radius: 8px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
    width: 100%;
    max-width: 400px;
    text-align: center;
}

.text-danger {
    color: #dc3545;
}

</style>